// Imported chart caches can be empty or stale. Source ranges are authoritative
// after workbook formulas have recalculated, including after an input edit.
export function refreshSpreadsheetCharts(charts, rows) {
  if (!Array.isArray(charts)) return charts;
  let changed = false;
  const next = charts.map(chart => {
    if (chart.sourceRangeStatus === 'unverified') return chart;
    const range = chart.sourceRange;
    const explicitColumns = range?.seriesColumns !== undefined;
    if (!range || !['r1', 'r2', 'c1', 'c2'].every(key => Number.isInteger(range[key]))
      || range.r1 < 0 || range.c1 < 0 || range.r2 < range.r1 || (explicitColumns ? range.c2 < range.c1 : range.c2 <= range.c1)
      || range.r2 >= rows.length || range.c2 >= (rows[range.r1]?.length || 0)
      || (range.r2 - range.r1 + 1) * (range.c2 - range.c1 + 1) > 10000) return chart;
    // Do not turn a malformed explicit mapping into a different adjacent range.
    if (explicitColumns && (!Array.isArray(range.seriesColumns) || !range.seriesColumns.length
      || range.seriesColumns.length !== chart.series?.length || range.seriesColumns.length > 6
      || !range.seriesColumns.every(column => Number.isInteger(column) && column >= 0 && column <= range.c2))) return chart;
    const start = range.headerRow === false ? range.r1 : range.r1 + 1;
    const count = chart.type === 'pie' ? 1 : explicitColumns ? range.seriesColumns.length : range.c2 - range.c1;
    const series = Array.from({ length: count }, (_, index) => {
      const old = chart.series?.[index] || {};
      const column = explicitColumns ? range.seriesColumns[index] : range.c1 + index + 1;
      const name = range.headerRow === false ? old.name : rows[range.r1]?.[column]?.v;
      const data = [];
      for (let row = start; row <= range.r2; row += 1) {
        const raw = rows[row]?.[column]?.v;
        // Missing/error results must not masquerade as measured zeros.
        const value = raw == null || (typeof raw === 'string' && !raw.trim()) || typeof raw === 'boolean' ? NaN
          : typeof raw === 'number' ? raw : Number(String(raw).replace(/,/g, ''));
        data.push({ x: String(rows[row]?.[range.c1]?.v ?? ''), y: Number.isFinite(value) ? value : null });
      }
      return { ...old, name: String(name || old.name || `Series ${index + 1}`), data };
    });
    if (JSON.stringify(series) === JSON.stringify(chart.series)) return chart;
    changed = true;
    return { ...chart, series };
  });
  return changed ? next : charts;
}
